import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { DecorationPreConfigForClient } from '../../../../../../public-session/src/graphql';
import { TypedFormBuilder } from '@ui/form/TypedFormBuilder';
import { Validators } from '@angular/forms';
import { PublicSessionContext } from '../../../../../../../graphql/apps/photographer/src/graphql';
import { PrivateSessionContext } from '../../../../../../photographer-panel/src/graphql';

@Component({
    selector: 'lib-look-book-missing-personalization-picker',
    templateUrl: './look-book-missing-personalization-picker.component.html',
    styleUrls: ['./look-book-missing-personalization-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LookBookMissingPersonalizationPickerComponent implements OnInit {
  saved = new Subject<Partial<DecorationPreConfigForClient>>();
  sessionOccasion: PublicSessionContext | PrivateSessionContext;

  model = this.form.typedGroup<Partial<DecorationPreConfigForClient>>({
    firstName: ['', Validators.required],
  });

  constructor(private form: TypedFormBuilder) {}

  ngOnInit(): void {}
}
